import { CompleteBasketItem } from '../../../providers/BasketProvider';
import { FC, ReactElement, ReactNode } from 'react';
import useMobileApp from '../../../hooks/mobile-app/useMobileApp';
import collect, { Collection } from 'collect.js';
import OrderBasketItemWeb from './OrderBasketItem';
import OrderBasketItemMobile from '../../../modules/mobile/components/basket/OrderBasketItem';
import BasketItemModifiers from '../BasketItemModifiers';

export interface IOrderBasketItemContent {
  renderDescription: () => ReactNode;
  getSoldOutItems: () => Collection<string>;
}

export interface IOrderBasketItem {
  data: CompleteBasketItem;
  index: number;
  hideDiscount?: boolean;
  editable?: boolean;
  coupon_type: number;
  onUpdateClick?: () => void;
  withImage?: boolean;
  extra?: ReactElement;
  classNames?: {
    itemContainer?: string;
    counterContainer?: string;
    counterQuantity?: string;
    counterButtons?: string;
    nonEditableQuantity?: string;
    badgeStyle?: string;
  };
}

const OrderBasketItem: FC<IOrderBasketItem> = (props) => {
  const { data } = props;
  const { isMobileApp } = useMobileApp();

  const renderDescription = () => <BasketItemModifiers item={data} />;

  const getSoldOutItems = (): Collection<string> => {
    return collect(data.modifiers)
      .pluck('entry')
      .where('is_available', false)
      .when(!data.entry.is_available, (items) => items.push(data.entry))
      .pluck('name');
  };

  const config = {
    ...props,
    renderDescription,
    getSoldOutItems,
  };

  return isMobileApp ? <OrderBasketItemMobile {...config} /> : <OrderBasketItemWeb {...config} />;
};

export default OrderBasketItem;
